<aside class="simulation__panel grid-container adhesion-stepper">
    <nav class="simulation__stepper">
        <ul class="simulation__stepperList grid-container">
            <li *ngFor="let step of steps; index as i" class="stepper" [ngClass]="{ 'stepper--active': step.isCurrent }" [style.flex-basis.%]="100 / steps.length">
                <span class="stepper__index">{{ i + 1 }}</span>
                <p class="stepper__name">{{ step.title }}</p>
            </li>
        </ul>
        <p *ngIf="currentStep" class="stepper__nameMobile">
            {{ currentStep.title }}
        </p>
    </nav>
</aside>
